// extracted by mini-css-extract-plugin
export var standaloneTable = "_ez-0";
export var standaloneTableWithBodyFill = "_ez-1";
export var withExtraHeader = "_ez-2";